import { notifications, type NotificationData } from "@mantine/notifications";

import { SYSTEM_COLORS } from "@/configs/colorScheme";
import Icon from "@/utils/icons";

import classes from "./notifications.module.css";

const defaultNotificationProps: NotificationData = {
  message: "",
  withCloseButton: true,
  withBorder: true,
  radius: "md",
};

const successNotificationProps: NotificationData = {
  ...defaultNotificationProps,
  icon: <Icon.CHECK size={22} />,
  color: SYSTEM_COLORS.success,
};
const infoNotificationProps: NotificationData = {
  ...defaultNotificationProps,
  icon: <Icon.INFO size={22} />,
  color: SYSTEM_COLORS.info,
};
const warningNotificationProps: NotificationData = {
  ...defaultNotificationProps,
  icon: <Icon.WARNING size={22} />,
  color: SYSTEM_COLORS.warning,
  classNames: classes,
};
const errorNotificationProps: NotificationData = {
  ...defaultNotificationProps,
  icon: <Icon.ERROR size={22} />,
  color: SYSTEM_COLORS.error,
  classNames: classes,
};

export const notify = {
  success: (text?: string, title?: string, options?: Partial<NotificationData>) =>
    notifications.show({ ...successNotificationProps, ...options, title, message: text }),
  info: (text?: string, title?: string, options?: Partial<NotificationData>) =>
    notifications.show({ ...infoNotificationProps, ...options, title, message: text }),
  warning: (text?: string, title?: string, options?: Partial<NotificationData>) =>
    notifications.show({ ...warningNotificationProps, ...options, title, message: text }),
  error: (text?: string, title?: string, options?: Partial<NotificationData>) =>
    notifications.show({ ...errorNotificationProps, ...options, title, message: text }),
};

export function useNotifications() {
  return notify;
}
